<template>
    <v-container v-if="superUser || permission" fluid>
        <v-sheet class="pa-3">
            <v-toolbar flat height="80">
                <v-btn
                    :disabled="!getPermission('create')"
                    color="secondary"
                    class="text-capitalize px-5"
                    depressed
                    v-text="translations.createWebhook[lang]"
                    @click="openDetailsDialog()"
                ></v-btn>
                <v-spacer></v-spacer>
                <!-- <v-col cols="12" sm="4" class="pt-0">
                    <b-select
                        :items="disabledStatuses"
                        :item-text="`name[${lang}]`"
                        item-value="value"
                        v-model="disabled"
                        noClearIcon
                        :label="translations.status[lang]"
                    ></b-select>
                </v-col> -->
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :loading="loading"
                :items="webhooks"
                class="b-outlined rounded-0 webhooks-table"
                disable-pagination
                hide-default-footer
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
            >
                <template v-slot:item.enable="{ item }">
                    <div class="d-flex justify-center align-center">
                        <v-switch
                            :disabled="!getPermission('update')"
                            class="mt-0"
                            v-model="item.enable"
                            inset
                            color="success"
                            hide-details
                            @change="
                                updateWebhook({
                                    id: item.store_event_id,
                                    body: { enable: item.enable }
                                })
                            "
                        ></v-switch>
                    </div>
                    <!-- <v-icon v-if="item.enable" color="green" size="28" v-text="icons.mdiCheckCircle"></v-icon> 
                    <v-icon v-else size="28" color="red" v-text="icons.mdiCloseCircle"></v-icon>  -->
                </template>
                <template v-slot:item.authorization="{ item }">
                    <div
                        v-if="item.authorization"
                        class="d-flex flex-column justify-center align-center pt-2 pb-2"
                    >
                        <!-- <div v-if="item.authorization.token || item.authorization.key || item.authorization.password" class="d-flex flex-column justify-center align-center pt-2 pb-2"> -->
                        <div
                            v-for="key in Object.keys(item.authorization)"
                            :key="key"
                            class="d-flex flex-column justify-center align-center pt-2 pb-2"
                        >
                            <span class="font-weight-bold px-1">{{
                                key.toUpperCase()
                            }}</span>
                            <!-- <span v-if="item.authorization.token" class="font-weight-bold px-1">Bearer</span>
                            <span v-else-if="item.authorization.key" class="font-weight-bold px-1">API</span>
                            <span v-else-if="item.authorization.password" class="font-weight-bold px-1">Basic</span> -->
                            <span
                                v-for="credential in Object.keys(
                                    item.authorization[key]
                                )"
                                :key="credential"
                                class="d-flex align-center"
                            >
                                {{ credential
                                }}<v-icon
                                    size="16"
                                    v-text="icons.mdiArrowRightBold"
                                ></v-icon>
                                {{ item.authorization[key][credential] }}</span
                            >
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                </template>

                <template v-slot:item.event_types="{ item }">
                    <v-chip
                        v-if="item.event_types && item.event_types.length === 1"
                        class="font-weight-bold px-1 pr-2 pl-2"
                        style="overflow: visible;"
                    >
                        {{ getEventType(item.event_types[0]) }}
                    </v-chip>

                    <v-tooltip
                        v-else-if="
                            item.event_types && item.event_types.length > 1
                        "
                        color="secondary"
                        top
                        close-delay="100"
                        allow-overflow
                        max-width="80%"
                    >
                        <template v-slot:activator="{ on }">
                            <v-chip
                                class="font-weight-bold px-1 pr-2 pl-2"
                                style="overflow: visible;"
                                v-on="on"
                            >
                                {{ item.event_types.length }} events
                            </v-chip>
                        </template>
                        <v-chip-group column class="event-chips">
                            <v-chip
                                v-for="(eventId, index) in item.event_types"
                                :key="index"
                                class="font-weight-bold px-1 pr-2 pl-2"
                                style="overflow: visible;"
                            >
                                {{ getEventType(eventId) }}
                            </v-chip>
                        </v-chip-group>
                    </v-tooltip>
                </template>
                <template v-slot:item.created_at="{ item }">
                    <span class="font-weight-bold px-1">{{
                        localizeDate(item.created_at, true)
                    }}</span>
                </template>
                <template v-slot:item.store_event_id="{ item }">
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="!getPermission('update')"
                                class="mr-1"
                                icon
                                color="secondary"
                                v-on="on"
                                @click="openDetailsDialog(item)"
                            >
                                <v-icon
                                    v-text="icons.mdiPencilOutline"
                                ></v-icon>
                            </v-btn>
                        </template>
                        <span class="font-weight-bold">{{
                            translations.edit[lang]
                        }}</span>
                    </v-tooltip>
                </template>
            </v-data-table>

            <v-dialog v-model="detailsDialog" max-width="500">
                <WebhookForm
                    :is-open="detailsDialog"
                    @cancel="detailsDialog = false"
                    @close="detailsDialog = false"
                />
            </v-dialog>
        </v-sheet>
    </v-container>
</template>

<script>
import {
    mdiCheckCircleOutline,
    mdiMinusCircleOutline,
    mdiClose,
    mdiCheckboxMarkedOutline,
    mdiTableEye,
    mdiPencilOutline,
    mdiArrowRightBold,
    mdiCheckCircle,
    mdiCloseCircle,
    mdiCheck,
    mdiListBox
} from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import WebhookForm from "@/components/general/settings/developers/WebhookForm";
import translations from "@/utils/translations/general/settings/developers";

export default {
    name: "Webhooks",

    components: { WebhookForm },

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiCheckCircleOutline,
                mdiMinusCircleOutline,
                mdiClose,
                mdiCheckboxMarkedOutline,
                mdiTableEye,
                mdiPencilOutline,
                mdiArrowRightBold,
                mdiCheckCircle,
                mdiCloseCircle,
                mdiCheck,
                mdiListBox
            },
            detailsDialog: false,
            sortBy: "store_event_id",
            sortDesc: true,
            disabled: null,
            disabledStatuses: [
                {
                    name: {
                        en: "Enabled",
                        el: "Eνεργοποιημένα",
                        it: "Abilitata"
                    },
                    value: "false"
                },
                {
                    name: {
                        en: "Disabled",
                        el: "Απενεργοποιημένα",
                        it: "Disabilitati"
                    },
                    value: "true"
                },
                {
                    name: {
                        en: "All",
                        el: "Όλα",
                        it: "Tutti"
                    },
                    value: null
                }
            ],
            logsDialog: false,
            logsWebhook: {}
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "permissions",
            "storePermissions"
        ]),

        ...mapState("general/settings/developers/webhooks", [
            "events",
            "webhooks",
            "webhook"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        query() {
            let query = "?";
            for (let key in this.$route.query) {
                if (this.$route.query[key]) {
                    query += `${key}=${this.$route.query[key]}&`;
                }
            }
            return query.slice(0, query.length - 1);
        },
        permission() {
            return (
                this.superUser ||
                (this.$store.state.permissions
                    ? this.$store.state.permissions.developers?.webhooks.read
                    : null)
            );
        },

        headers() {
            return [
                {
                    text: "URL",
                    value: "endpoint_url",
                    align: "center",
                    width: 200
                },

                {
                    text: this.translations.eventTypes[this.lang],
                    value: "event_types",
                    align: "center",
                    width: 100
                },
                {
                    text: this.translations.enabled[this.lang],
                    value: "enable",
                    align: "center",
                    width: 80
                },

                {
                    text: this.translations.actions[this.lang],
                    value: "store_event_id",
                    align: "center",
                    width: 50
                }
            ];
        }
    },

    methods: {
        ...mapActions("general/settings/developers/webhooks", [
            "getAllEvents",
            "getAllWebhooks",
            "getWebhook",
            "createWebhook",
            "updateWebhook"
        ]),
        ...mapMutations(["setDeleteDialog", "setNotification", "setLoading"]),
        ...mapMutations("general/settings/developers/webhooks", [
            "setWebhooks",
            "setWebhook"
        ]),

        localizeDate(date, short) {
            return date
                ? new Date(date).toLocaleString(this.locale, {
                      weekday: short ? undefined : "long",
                      year: "numeric",
                      month: short ? "numeric" : "long",
                      day: "numeric"
                  })
                : "-";
        },

        getEventDescription(id) {
            return (
                ((this.events || []).find(x => x.id == id) || {}).description?.[
                    this.lang
                ] || ""
            );
        },

        getEventType(id) {
            return ((this.events || []).find(x => x.id == id) || {}).type || "";
        },

        openDetailsDialog(item) {
            this.setWebhook(item ? { ...item } : {});
            this.detailsDialog = true;
        },
        openLogsDialog(item) {
            this.logsWebhook = item;
            this.logsDialog = true;
        },

        getPermission(path) {
            return (
                this.superUser ||
                (eval("this.permissions.developers.webhooks." + path) &&
                    eval("this.storePermissions.developers.webhooks." + path))
            );
        }
    },

    watch: {
        $route(val) {
            this.getAllWebhooks(this.query);
        },

        disabled(val) {
            let q = val;
            if (val === null) {
                q = undefined;
            }
            this.$router.replace({
                query: { ...this.$route.query, disabled: q }
            });
        }
    },

    mounted() {
        this.disabled = this.$route.query.disabled;
        if (this.disabled == undefined) this.disabled = null;
        this.setWebhooks([]);
        this.getAllEvents();
        // console.log(typeof this.$route.query.disabled)
        // if (typeof this.disabled !== 'boolean' && (this.disabled == "true" || this.disabled == "false")) {
        //     this.disabled = (this.disabled == 'true')
        // }else if (typeof this.disabled !== 'boolean') {
        //     this.disabled = null
        // }
        this.getAllWebhooks(this.query);
    }
};
</script>

<style>
.webhooks-table th {
    padding-left: 3px !important;
    padding-right: 3px !important;
}
.webhooks-table td {
    padding-left: 3px !important;
    padding-right: 3px !important;
}

.event-chips {
    max-height: 200px;
    overflow: scroll;
}
.event-chips .v-slide-group__wrapper {
    overflow: scroll;
}
</style>
